import { tokens, tsr } from '../../lib/api.js';
import { orgSubdomainOrigin } from '../../lib/subdomain.js';
import { coursePagePath } from '../../routes/admin/training/courses/courseStatus.js';

/** The course's page inside a company: the same address the company's own admins use. */
export function companyCoursePath(taskId: string): string {
  return coursePagePath(taskId);
}

/**
 * The address that signs the caller in on a company's own subdomain and lands on `path`. The code
 * is single-use; `next` is a path on that company's own address (SessionHandoff refuses anything
 * else), so it is always a relative path here.
 */
export function sessionHandoffUrl(origin: string, code: string, path: string): string {
  const next = path.startsWith('/') && !path.startsWith('//') ? path : '/';
  return `${origin}/session-handoff?code=${encodeURIComponent(code)}&next=${encodeURIComponent(next)}`;
}

/**
 * Lands the browser on `path` in another company, signed in there. Same mechanics as the company
 * switch (`goToCompany` in company-group/useCompanyGroup.ts), which cannot carry a path: a session
 * lives in one address's storage, so the code crosses the redirect and is redeemed on the other
 * side. `localhost` has no real subdomains, so there the code is redeemed in place.
 */
export async function goToCompanyAt(slug: string, code: string, path: string): Promise<void> {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    const redeemed = await tsr.auth.redeemSessionHandoff.mutate({ body: { code } });
    if (redeemed.status === 200) await tokens.save(redeemed.body.tokens);
    window.location.assign(path);
    return;
  }
  window.location.href = sessionHandoffUrl(orgSubdomainOrigin(slug), code, path);
}
